<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Video' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <!-- add form -->
    <div class="card bg-light">
      <div class="card-body">

        <h4 class="card-title">{{'Add a new video' | translate}}</h4>

        <div class="form-group">
          <label>{{'Title' | translate}}</label>
          <input class="form-control" [(ngModel)]="entity.title" />
        </div>

        <div class="form-group">
          <label>{{'Description' | translate}}</label>
          <textarea class="form-control" [(ngModel)]="entity.description"></textarea>
        </div>

        <div class="form-group">
          <label>{{'URL' | translate}}</label>
          <input class="form-control" [(ngModel)]="entity.youtubeUri" />
          <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'youtubeUri')">
            <p>{{'Please fill in a url' | translate}}</p>
          </div>
        </div>

        <div class="btn-toolbar">
          <button class="btn btn-primary ml-auto" (click)="addVideo()">
            <fa-icon *ngIf="isProcessing" [icon]="faSpinner" animation="spin"></fa-icon>
            {{'Add' | translate}}
          </button>
        </div>

        <div class="mt-3 alert alert-success" *ngIf="isUploaded">
          {{ 'Successfully added' | translate }}
        </div>

      </div>
    </div>

    <div class="card mt-4" *ngIf="view.data.length > 0">
      <div class="card-body">

        <h4 class="card-title">{{'Saved videos' | translate}}</h4>

        <table class="table table-striped table-company-photo">

          <thead>
            <tr>
              <th>
                {{'Video' | translate}}
              </th>
              <th>
                {{'Title' | translate}}
              </th>
              <th>
                {{'Description' | translate}}
              </th>
              <th>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let video of view.data">
              <td>
                <a target="_blank" [href]="video.youtubeUri">
                  <img class="img-fluid img-responsive img-64" [src]="video['youtubeImageUri']">
                </a>
              </td>
              <td>
                {{video.title}}
              </td>
              <td>
                {{video.description}}
              </td>
              <td>
                <button class="btn btn-danger" (click)="deleteVideo(video.id)">
                  <fa-icon [icon]="faTimes"></fa-icon>
                </button>
              </td>

            </tr>
          </tbody>

        </table>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-end">
      <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>
